import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { useDebouncedInputValue } from '../../../hooks';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { nuc } from '../../../utils';
import { Select } from '../../generic';
import type { AnyFilter } from '../../../../shared/organizationPackages';
import type { SelectOption } from '../../../types';

const debounceTimeMs = 250;

type Props = {
  locators: SelectOption[];
  setFilters: (...args: AnyFilter[]) => void;
};

/**
 * Renders an autocomplete package locators dropdown
 */
const PackageLocatorFilter: VoidFunctionComponent<Props> = ({ locators, setFilters }) => {
  const dispatch = useDispatch();

  const { onChange: updateSearchValue, debouncedValue: debouncedSearchValue } = useDebouncedInputValue(
    '', // defaulting to an empty string for the initial search value to start with an empty filter
    debounceTimeMs,
  );

  useEffect(() => {
    dispatch(PackageInventoryStore.actions.fetchPackageLocators(nuc(debouncedSearchValue)));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch is a stable reference
  }, [debouncedSearchValue]);

  const options = useSelector(PackageInventoryStore.selectors.getPackageLocatorsOptions);

  return (
    <Select
      id="package-index-locator-filter"
      isMulti
      onInputChange={(searchValue => updateSearchValue(searchValue))}
      options={options}
      placeholder="Locators"
      value={locators}
      onChange={(selectedOptions: SelectOption[]) => {
        setFilters({
          locators: selectedOptions.map((option) => option.value),
        });
      }}
    />
  );
};

export default PackageLocatorFilter;
